import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import bg1 from '../../theme/assets/other/ftf_hiw_s4_bg1.png';
import bg2 from '../../theme/assets/other/ftf_hiw_s4_bg2.png';


const HiwS4 = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.elementWidthWP}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Ценность создаём мы сами')}</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={bg1} alt="crypto"/>
                        </div>
                        <div className={`${Styles.contentBoxItemText}`}>{t('Стоимость доллара, как и любая другая финансовая система, — всего лишь миф, придуманный людьми. Если мы смогли «запустить» доллар и придать ему ценность, то тем более можем сами формировать стоимость биткоина и любых других активов')}</div>.
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemText}`}>{t('Нам не нужен централизованный эмитент или регулятор, чтобы создавать и контролировать ценность. Мы сами выбираем, что и сколько стоит, и никакие внешние институты нам в этом не требуются')}</div>.
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={bg2} alt="crypto"/>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.contentWrapNote}`}>{t('Присоединяйтесь к нам — вместе мы сможем установить новую, честную и прозрачную систему ценностей, основанную на наших правилах и нашей ответственности')}</div>.
                <div className={`${Styles.ftfBackgroundBtn}`}>{t('Присоединиться')}!</div>
            </div>
        </section>
    );
};

export default HiwS4;
